iScreenWizard.factory('p2cService', function ($state, $rootScope) {

    var service = {

        model: {
            testafnames: []
        },

        SaveState: function () {
            localStorage.p2c = angular.toJson(service.model);
        },

        RestoreState: function () {
            if (typeof localStorage.p2c !== 'undefined') {
                service.model = angular.fromJson(localStorage.p2c);
            }
        }
    };

    $rootScope.$on("savestate", service.SaveState);
    $rootScope.$on("restorestate", service.RestoreState);

    service.RestoreState();

    return service;
});